import { Box, Grid, Typography } from "@mui/material";
import { formatNumber } from "utility/formatters";

const cellSx = {
  textAlign: "center",
};

const statsValueSx = {
  fontWeight: 800,
  mb: 0.75,
  fontSize: "1.5rem",
};

const statsLabelSx = {
  fontWeight: 700,
  color: "text.secondary",
};

export const YieldForecast = ({
  selectedCropType,
  isLoadingYieldForecast,
  isLoadingCountyData,
  isLoadingHistoricalYieldTrend,
  yieldForecastValues,
  rmaProjectedYieldIrrigated,
  rmaProjectedYieldNonIrrigated,
  rmaHistoricalYieldIrrigated,
  rmaHistoricalYieldNonIrrigated,
}) => {
  const showActuals = Boolean(rmaHistoricalYieldIrrigated || rmaHistoricalYieldNonIrrigated);

  return (
    <>
      <Typography className="section-title">DATANAC&trade; Yield Forecast - {selectedCropType}</Typography>
      {isLoadingYieldForecast || isLoadingCountyData || isLoadingHistoricalYieldTrend ? (
        <Box className="yield-forecast-loading">
          <Typography variant="body2" color="text.secondary">
            Loading...
          </Typography>
        </Box>
      ) : (
        <Box className="yield-forecast-container">
          <Grid container spacing={1} alignItems="flex-start">
            {/* DATANAC + RMA projected: 2×2 on xs, single row of four on sm+ */}
            <Grid item xs={6} sm={3} sx={cellSx}>
              <Typography
                color={"primary.main"}
                className="stats-value"
                sx={{
                  ...statsValueSx,
                  "[data-mui-color-scheme='dark'] &": { color: "primary.light" },
                }}
              >
                {yieldForecastValues.irrigated ? `${formatNumber(yieldForecastValues.irrigated, 1)}` : "--"}
              </Typography>
              <Typography variant="subtitle2" className="stats-label" sx={statsLabelSx}>
                Irrigated (bu)
              </Typography>
            </Grid>
            <Grid item xs={6} sm={3} sx={cellSx}>
              <Typography color={"secondary.main"} className="stats-value" sx={statsValueSx}>
                {yieldForecastValues.nonIrrigated ? `${formatNumber(yieldForecastValues.nonIrrigated, 1)}` : "--"}
              </Typography>
              <Typography variant="subtitle2" className="stats-label" sx={statsLabelSx}>
                Non-Irrigated (bu)
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sm={3}
              sx={{
                ...cellSx,
                borderTop: { xs: "1px solid", sm: "none" },
                borderColor: "divider",
                pt: { xs: 1, sm: 0 },
                borderLeft: { sm: "1px solid" },
                pl: { sm: 1 },
              }}
            >
              <Typography
                color={"primary.main"}
                className="stats-value"
                sx={{
                  ...statsValueSx,
                  "[data-mui-color-scheme='dark'] &": { color: "primary.light" },
                }}
              >
                {rmaProjectedYieldIrrigated ? `${formatNumber(rmaProjectedYieldIrrigated, 1)}` : "--"}
              </Typography>
              <Typography variant="subtitle2" className="stats-label" sx={statsLabelSx}>
                RMA insurance Yield (IRR)
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sm={3}
              sx={{
                ...cellSx,
                borderTop: { xs: "1px solid", sm: "none" },
                borderColor: "divider",
                pt: { xs: 1, sm: 0 },
              }}
            >
              <Typography color={"secondary.main"} className="stats-value" sx={statsValueSx}>
                {rmaProjectedYieldNonIrrigated ? `${formatNumber(rmaProjectedYieldNonIrrigated, 1)}` : "--"}
              </Typography>
              <Typography variant="subtitle2" className="stats-label" sx={statsLabelSx}>
                RMA insurance Yield (NI)
              </Typography>
            </Grid>

            {showActuals && (
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    borderTop: "1px solid",
                    borderColor: "divider",
                    pt: 1.25,
                    mt: 0.25,
                  }}
                >
                  <Grid item sm={6} sx={{ display: { xs: "none", sm: "block" } }} aria-hidden />
                  <Grid item xs={6} sm={3} sx={cellSx}>
                    <Typography
                      color={"primary.main"}
                      className="stats-value"
                      sx={{
                        ...statsValueSx,
                        "[data-mui-color-scheme='dark'] &": { color: "primary.light" },
                      }}
                    >
                      {rmaHistoricalYieldIrrigated ? `${formatNumber(rmaHistoricalYieldIrrigated, 1)}` : "--"}
                    </Typography>
                    <Typography variant="subtitle2" className="stats-label" sx={statsLabelSx}>
                      RMA Actuals (IRR)
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={3} sx={cellSx}>
                    <Typography color={"secondary.main"} className="stats-value" sx={statsValueSx}>
                      {rmaHistoricalYieldNonIrrigated ? `${formatNumber(rmaHistoricalYieldNonIrrigated, 1)}` : "--"}
                    </Typography>
                    <Typography variant="subtitle2" className="stats-label" sx={statsLabelSx}>
                      RMA Actuals (NI)
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </>
  );
};
